import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsByRegionIdAndSportId = QueryFactory(SD.QueryTypes.GetEventsByRegionIdAndSportId);
//# sourceMappingURL=QGetEventsByRegionIdAndSportId.js.map